import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * This store contains all responses / data from the API endpoints
 * use for this app
 */
export const useApiResponsesStore = defineStore('api-responses', () => {
    const countryResponses = ref({
        name: null,
        countryProfile: null,
        numericCode: null,
        workingHours: null,
        occupationMonthlyCosts: null,
        socialSecurityTaxes: {
            withOverhead: null,
            withoutOverhead: null,
        }
    });
    const regionResponses = ref({
        annualLivingWages: null,
        quarterlyLivingWages: null,
        regions: null,
    });
    const occupationResponses = ref({
        gigData: null,
        levelOneOccupations: null,
        levelTwoOccupations: null,
    });

    return {
        countryResponses,
        regionResponses,
        occupationResponses,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(
        acceptHMRUpdate(useApiResponsesStore, import.meta.hot)
    );
}
